import React, { useEffect, useState } from 'react';
import { CloseOutlined } from '@ant-design/icons';
import { Modal, Input, message } from 'antd';
import { useCreateOrganization, useGetOrganizationMembers, useInviteMemeber, useUpdateOrganization, } from '../../networking/useOrganization';
import { FormView } from '../../components/base/FormView';
import { isNonEmpty } from '../../utils/arrayUtils';
import { Button, ListItems, Loading, Text, TextInput } from '../../components/base';
import { useOrganization } from '../../providers/OrganizationProvider';
export const OrganizationView = () => {
    const [orgName, setOrgName] = useState(null);
    const [manageMembers, setManageMembers] = useState(false);
    const [orgMembersEntries, setMembersEntries] = useState([]);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [inputText, setInputText] = useState('');
    const { isLoading: isLoadingCreate, statusCode, data: dataCreate, call: callCreate } = useCreateOrganization();
    const { isLoading, organization, setOrganization } = useOrganization();
    const { isLoading: isLoadingUpdate, statusCode: statusCodeUpdate, data: dataUpdate, call: callUpdate, } = useUpdateOrganization();
    const { isLoading: isLoadingInvite, data, call: callInvite } = useInviteMemeber();
    const { isLoading: isLoadingMembers, data: orgMembers, call: callGetOrgMembers } = useGetOrganizationMembers();
    // const {
    //   isLoading: isLoadingDeleteMembers,
    //   data: dataDeleteMembers,
    //   call: callDeleteOrgMembers,
    // } = useDeleteOrganizationMembers();
    const displayMapping = {
        display_name: 'Name',
        credit_balance: 'Credit balance ($)',
    };
    const handleInvite = () => {
        callInvite({ email: inputText });
        message.info('Invitation sent');
        setIsModalVisible(false);
    };
    const handleCancel = () => {
        setIsModalVisible(false);
    };
    useEffect(() => {
        if (!statusCode)
            return;
        if (statusCode === 409) {
            alert('Could not create organization. Try another name.');
        }
        if (dataCreate && isNonEmpty(dataCreate)) {
            setOrganization(dataCreate[0]);
        }
    }, [statusCode, dataCreate]);
    useEffect(() => {
        if (!statusCodeUpdate)
            return;
        if (statusCodeUpdate === 409) {
            alert('Could not update organization. Try another name.');
        }
    }, [statusCode, dataUpdate]);
    useEffect(() => {
        if (orgMembers && isNonEmpty(orgMembers)) {
            const entries = orgMembers.map((member) => ({
                header: member.email,
                subheader: member.status,
                content: undefined,
                loading: false,
                buttons: [
                    React.createElement(Button, { text: "Remove", onClick: () => {
                            // callDeleteOrgMembers({ entity_id: member.id });
                            alert('Ask the Relyant team to remove a member from the organization');
                        } }),
                ],
            }));
            setMembersEntries(entries);
            setManageMembers(true);
        }
    }, [orgMembers]);
    const onCreate = () => {
        if (!orgName) {
            alert('Please fill in the organization name');
            return;
        }
        const newOrganization = { name: orgName };
        callCreate({ entities: [newOrganization] });
    };
    const onUpdate = (orgId, fieldsToUpdate) => {
        callUpdate({ entity_id: orgId, fields_to_update: fieldsToUpdate });
    };
    if (isLoading || isLoadingCreate) {
        return React.createElement(Loading, null);
    }
    if (!organization) {
        return (React.createElement("div", { style: { width: '50%', margin: 'auto', textAlign: 'center' } },
            React.createElement(Text, { value: 'Complete the profile creating an organization', className: "header2" }),
            React.createElement(Text, { style: { paddingTop: 8, paddingBottom: 8 }, value: 'Or wait for an invitation to join', className: "header3" }),
            React.createElement("div", { className: "flex-column", style: { paddingTop: 24, gap: 12 } },
                React.createElement(TextInput, { value: orgName, placeholder: 'Enter organization name', setText: (text) => setOrgName(text), style: { textAlign: 'center', maxWidth: 512, margin: 'auto' } }),
                React.createElement(Button, { text: "Create organization", onClick: onCreate, type: "secondary" }))));
    }
    return (React.createElement("div", null,
        React.createElement(FormView, { headerForm: 'Organization', data: organization, isLoading: isLoadingUpdate, displayMapping: displayMapping, onCreate: onCreate, onUpdate: onUpdate }),
        React.createElement("div", { style: { marginTop: 24 } },
            !manageMembers && (React.createElement(Button, { text: "Manage members", isLoading: isLoadingMembers, onClick: () => {
                    callGetOrgMembers();
                } })),
            manageMembers && (React.createElement("div", { className: "flex-column", style: { maxHeight: '75vh', backgroundColor: 'white', padding: 24, borderRadius: 8 } },
                React.createElement("div", { className: "flex-row", style: { justifyContent: 'flex-end' } },
                    React.createElement(CloseOutlined, { onClick: () => setManageMembers(false) })),
                React.createElement(Text, { value: 'Members', className: "header2" }),
                React.createElement(ListItems, { itemLayout: "horizontal", items: orgMembersEntries }),
                React.createElement(Button, { text: "Add member", onClick: () => setIsModalVisible(true), style: { width: '50%', margin: 'auto' } }),
                React.createElement(Modal, { title: "Enter email of member to invite", open: isModalVisible, onOk: handleInvite, onCancel: handleCancel },
                    React.createElement(Input, { value: inputText, onChange: (e) => setInputText(e.target.value), placeholder: "Type email" })))))));
};
